module.exports = __webpack_public_path__ + "img/colored-line-graph-icon-21022022.d04873d3.svg";